module.exports = __webpack_public_path__ + "media/images/placeholder_jt-a75c2ca2c664b73ecd47eb7cbbac5b19.png";